"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactComponents = require("@cimpress/react-components");

var Robot = _reactComponents.shapes.Robot;

var ErrorRobot = function ErrorRobot(_ref) {
  var title = _ref.title,
      msg = _ref.msg,
      _ref$includeContact = _ref.includeContact,
      includeContact = _ref$includeContact === void 0 ? true : _ref$includeContact;
  var titleRender = title;
  var msgRender = msg;

  if (typeof title === 'string') {
    titleRender = _react["default"].createElement("h3", null, title);
  }

  if (typeof msg === 'string') {
    msgRender = _react["default"].createElement("h5", null, msg);
  }

  return _react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, titleRender, _react["default"].createElement(Robot, {
    bsStyle: "danger",
    size: "sm"
  }), msgRender, includeContact && _react["default"].createElement("h5", null, "If you need assistance, please contact", ' ', _react["default"].createElement("a", {
    href: "mailto: FinancialFlowsSupport@cimpress.com?subject=Issues with quick contract create flow"
  }, "FinancialFlowsSupport@cimpress.com")));
};

var _default = ErrorRobot;
exports["default"] = _default;